import changeCart from './changeCart';

export default function resetCustomerCardInCart() {
  return changeCart({
    itemChanges: [],
    customerCard: undefined,
    externalBilling: undefined,
  });
}
